/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60); // hourly checks
    },
    cached() {
      console.log('Content has been cached for offline use.')
      window.kapp.$notify({
        group: 'serviceWorker',
        clean: true,
      })
    },
    updatefound() {
      console.log('New content is downloading.')
      window.kapp.$notify({
        group: 'serviceWorker',
        type: 'warn',
        title: 'Application update',
        text: 'Please wait, new content is downloading.',
        duration: -1,
      })
    },
    updated() {
      console.log('New content is available; please refresh.')
      window.kapp.$notify({
        group: 'serviceWorker',
        clean: true,
      })
      window.kapp.$notify({
        group: 'serviceWorker',
        type: 'success',
        title: 'Application update',
        text: 'New content is available; please close and reopen the application.',
        duration: 15,
      })
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
